export default __webpack_public_path__ + "static/media/SHOP ON EASE.5176e6f9.png";